module.exports = __webpack_public_path__ + "img/chinesecompany68.cc6b8be2.png";